import './SingleHouse.scss'
import { useParams, Link } from 'react-router-dom'
import { houses } from '../../../../Dummy Data/Houses'
import bgImg from '../../../../assets/walpaper4.jpg'
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import HouseDescriptions from './description/HouseDescriptions';
const SingleHouse = () => {

    const { title } = useParams()
    const singleHouse = houses.find(house => house.title === title)

  return (
    <div className='single-house'>
        <img className="background-fixed" src={bgImg} alt="background-img" />
    <div className="overlay-container">
        <div className="single-nav-bar">
            <div className="single-nav-items">
                <p><Link to="" >Descriptions & features</Link></p>
                <p><Link to="" >Gallery</Link></p>
            </div>
        </div>

        <div className="single-img-des">
            <div className="slider-img">
                <img src={singleHouse.image} alt="single-house-img" width={100} />
            </div>
            <div className="simple-desc">
                <h2><i className="fa-solid fa-location-dot location"></i>{singleHouse.location}</h2>
                <h2><span className='dollar'>$</span>{singleHouse.price}</h2>
                <h2><i className="fa-solid fa-phone phone"></i> <a href="tel:+250780845014">+250780845014</a></h2>
            </div>

             {/* Next prev buttons */}
            <div className="next-prev-btns">
                <div className="prev arrow-btn">
                    <ArrowLeftIcon  className='move-icon'/>
                </div>
                <div className="next arrow-btn">
                    <ArrowRightIcon
                    className='move-icon'/>
                </div>
            </div>
        </div>
        <HouseDescriptions singleHouse={singleHouse}/>
    </div>

    </div>
  )
}

export default SingleHouse
